<template>
    <div>
        <div class="topbar" @click="m_clickTopBar_f">

            <div class="header TQ_grid_center">
                <slot name="header"> </slot>
            </div>
            <div class="right TQ_grid_center" v-if="pf_toggleActive_b">
                <img v-if="!show" :src="ass_img_arrow_down_b" >
                <img v-if="show"  :src="ass_img_arrow_up_b">
            </div>
        </div>

        <div v-if="show">
            <slot name="body"></slot>
        </div>
    </div>

</template>

<script>
    import OnTopContainer from "./TqOnTopContainer";
    import {ass_img_arrow_down_b, ass_img_arrow_up_b} from "@/assets/scripts/Ass_Files";
    export default {
        name: "TqToggleDiv",
        components: {OnTopContainer},
        props:{
            p_initShow_b : {
                type: Boolean,
                default: false
            },
            pf_toggleActive_b: {
                type : Boolean,
                default: true
            }
        },
        data(){
            return{
                show: this.p_initShow_b,
                ass_img_arrow_down_b : ass_img_arrow_down_b,
                ass_img_arrow_up_b : ass_img_arrow_up_b
            }
        },
        methods:{
            m_clickTopBar_f(){
                if(this.pf_toggleActive_b){
                    this.show=!this.show
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .topbar{
        cursor: pointer;
        margin: 4px 8px;
        display: grid;
        grid-template-columns:1fr auto;
        padding-bottom: 4px;
        border-bottom: 2px solid black;

        .right {
            img{
                width: 32px;
            }
        }
    }

</style>
